<template>
  <div class="preview-one-container">
    <div class="p-content-container" :style="{ backgroundColor: logoBackgroundColor }">
      <img src="@shared/assets/img/promo/preview-one.png" class="p-shell-img" alt="Preview" />
      <div class="p-header-container">
        <div v-if="partnerSettings.LOGO_URL" class="bp-logo-container">
          <img
            v-if="partnerSettings.LOGO_URL"
            class="bp-logo"
            :src="partnerSettings.LOGO_URL"
            alt="Logo"
          />
        </div>
        <div v-else class="bp-logo-container">
          <span class="bp-company-name">{{
            currentCorporation?.displayName || currentCorporation?.corporationName
          }}</span>
        </div>
      </div>
      <div class="p-body-container">
        <div
          class="p-card-container"
          :style="{
            backgroundImage: imagePreviewOne ? `url(${imagePreviewOne})` : '',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }"
        >
          <div class="p-image-overlay" />
          <div class="p-text-container">
            <div class="promo-name">
              {{ promo.promoName || 'Promo Name' }}
            </div>
            <div class="promo-exp-date-row">
              <div class="flex-row align-center">
                <img class="money-icon" src="@shared/assets/img/promo/money-icon.svg" alt="Icon" />
                <div class="promo-exp-date">
                  {{ formatDate(promo.endDate) || 'Expiration Date' }}
                </div>
              </div>
              <div class="promo-details">Details</div>
            </div>
          </div>
        </div>
        <div class="p-balance-container">
          <div class="promo-cc-balance">{{ loyaltyName }} Balance</div>
          <img
            class="detail-btn"
            src="@shared/assets/img/promo/detail-btn-light.svg"
            alt="Detail"
          />
        </div>
        <div class="promo-credit-amount-container">
          <div class="promo-dollars">$</div>
          <div class="promo-price">250</div>
        </div>
        <div class="promo-cc-container">
          <div class="promo-cc-transac">{{ loyaltyName }} Bonus</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import promoMixin from '@shared/mixins/promoMixin';

export default {
  name: 'PreviewOne',
  mixins: [promoMixin],
  props: {
    promo: Object,
    partnerSettings: Object,
    currentCorporation: Object,
    imagePreviewOne: String,
  },
  computed: {
    loyaltyName() {
      return this.partnerSettings.LOYALTY_PROGRAM_NAME || 'Comfort Credits';
    },
    logoBackgroundColor() {
      if (!this.partnerSettings.PRIMARY_COLOR || this.partnerSettings.PRIMARY_COLOR === '#FFFFFF') {
        return '#121830';
      }
      return this.partnerSettings.PRIMARY_COLOR;
    },
  },
  methods: {
    formatDate(endDate) {
      if (!endDate) {
        return null;
      }
      return `until ${moment(endDate).format('M/DD/YY')}`;
    },
  },
};
</script>

<style lang="scss">
.preview-one-container {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 320px;
  height: 600px;
  margin-right: 20px;

  .p-content-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;

    .p-shell-img {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1;
    }

    .p-header-container {
      display: flex;
      justify-content: center;
      padding-top: 24px;

      .bp-logo-container {
        height: 70px;
        width: 70px;
        display: flex;
        align-items: center;
        justify-content: center;

        .bp-logo {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .bp-company-name {
          font-size: 1rem;
          color: $N10;
          font-weight: 600;
          text-wrap: nowrap;
        }
      }
    }

    .p-body-container {
      flex: 1;
      z-index: 2;
      padding: 50px 16px 0;
      display: flex;
      flex-direction: column;

      .p-card-container {
        width: 100%;
        height: 81px;
        background-color: $NBLUE100;
        border-radius: 8px;
        position: relative;
        .p-image-overlay {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background-color: $N100;
          opacity: 0.5;
          border-radius: 8px;
        }
        .p-text-container {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          z-index: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 12px 8px;
          .promo-name {
            color: $WHITE;
            font-size: 12px;
            font-weight: 600;
          }

          .promo-exp-date-row {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .promo-exp-date {
              color: $WHITE;
              margin-left: 5px;
              font-size: 10px;
            }

            .money-icon {
              width: 25.7px;
              height: 25.7px;
            }

            .promo-details {
              color: $WHITE;
              text-decoration: underline;
              font-size: 0.6rem;
              font-weight: 800;
            }
          }
        }
      }

      .p-balance-container {
        display: flex;
        align-items: center;
        margin-top: 24px;

        .promo-cc-balance {
          color: $WHITE;
          font-size: 1.125rem;
          font-weight: 600;
          white-space: nowrap;
          max-width: 90%;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .detail-btn {
          width: 28px;
          height: 28px;
        }
      }

      .promo-credit-amount-container {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        margin-bottom: 20px;

        .promo-dollars {
          color: $WHITE;
          font-size: 0.875rem;
          font-weight: 700;
          margin-top: 8px;
        }

        .promo-price {
          color: $WHITE;
          font-size: 2rem;
          font-weight: 600;
        }
      }

      .promo-cc-container {
        flex: 1;
        display: flex;
        align-items: flex-end;

        .promo-cc-transac {
          color: $WHITE;
          font-size: 0.9rem;
          font-weight: 500;
          padding-bottom: 49px;
          padding-left: 53px;
          white-space: nowrap;
          overflow: hidden;
          max-width: 80%;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
